import PropTypes from 'prop-types'
import React from 'react'
import { useStore } from 'react-redux'
import { useSortBy, useTable } from 'react-table'
import '../../../globals/scss/components/tableview.scss'
import { RenderIf } from '../../../utils/fns'
import { OPTIMIZED_MODELS_LENGTH } from '../../../utils/constants'
import { selectOutputState } from '../store/slices/output.slice'

export const TableViewPrint = (props) => {
  const { title, columns, data, sortBy } = props
  const state = useStore().getState()
  const { showAllModels } = selectOutputState(state)

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data,
      initialState: { sortBy },
    },
    useSortBy,
  )

  const optimizedRows =
    showAllModels || rows.length <= OPTIMIZED_MODELS_LENGTH
      ? rows
      : rows.slice(0, OPTIMIZED_MODELS_LENGTH)

  return (
    <section className="tableGroup">
      <h3 className="tableTitle">{title}</h3>

      <div className="nonScrollable">
        <table className="-striped -highlight" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    key={column.id}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className={
                      column.isSorted
                        ? column.isSortedDesc
                          ? '-sortDescending'
                          : '-sortAccending'
                        : ''
                    }
                  >
                    {column.render('Header')}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {optimizedRows?.map(
              (row) =>
                prepareRow(row) || (
                  <tr key={row.id} {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td key={cell.id} {...cell.getCellProps()}>
                          {cell.render('Cell')}
                        </td>
                      )
                    })}
                  </tr>
                ),
            )}
          </tbody>
        </table>
      </div>

      {RenderIf(
        optimizedRows.length === 0,
        <div className="notice -warning">
          <img
            data-src="assets/images/icons/sst-icon-info.svg"
            className="notice__icon iconic iconic-md injectSVG"
            alt="info"
          />
          <div className="notice__text">
            <div className="notice__header">No Matching Records Found</div>
            <div className="notice__body">Try editing or deleting your search criteria.</div>
          </div>
        </div>,
      )}
    </section>
  )
}

TableViewPrint.propTypes = {
  title: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  sortBy: PropTypes.arrayOf(PropTypes.any),
}
